// tslint:disable
/* MACLE TypeScript 10/01/2026 17:44:34 */
import { BaseData } from './maf.vo';
import { ArrayList } from 'maf-web';

export class PKVitrine extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.PKVitrine";
  codVitrine: number = 0;

  constructor()
  constructor(codVitrine: number)
  constructor(codVitrine?: number) {
    super();
    this.codVitrine = codVitrine || 0;
  }

  public getPK(): PKVitrine {
    return new PKVitrine(this.codVitrine);
  }

  public equals(arg: PKVitrine): boolean {
    return arg 
        && (arg.codVitrine === this.codVitrine)
    ;
  }
}


export class DataVitrine extends PKVitrine {
  readonly jclass: string = "com.liquidacaoParcela.vo.DataVitrine";
  logoBase64: string = "";
  urlVitrine: string = "";
  descricao: string = "";
}


export class ConsVitrineAndItem extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.ConsVitrineAndItem";
  vitrine: DataVitrine = new DataVitrine();
  listItens: string[] = [];
}


